<!-- <div class="container" style="margin-top: 100px;"> -->

<div style="margin-inline: 300px !important;">
  <app-invoice-details printPreviewOnly="true" ngxPrintItem directPrint="true" id="print-section" [invoice]="invoice"></app-invoice-details>
</div>

<button (click)="printerMarkerClicked()" class="btn btn-sm btn-primary">
  {{"print"|translate}}
</button>

<!-- <button class="btn btn-sm btn-primary" [useExistingCss]="true" printSectionId="print-section" ngxPrint>
  {{"print"|translate}}
</button> -->
